var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#1D97F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H13V12H7V8Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#1D97F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#1D97F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseManagement);
export default __webpack_public_path__ + "static/media/LicenseManagement.47b23101349b74064706782a450cdc4e.svg";
export { ForwardRef as ReactComponent };